// extracted by mini-css-extract-plugin
export default {"page-choice-panel":"HrEmployeeGroup_page-choice-panel__6TY0X"};